export default function FixedPosition(props)
{
    return (
        <div style={{
            position: props.fixed ? 'fixed' : 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100vh',
            zIndex: props.zIndex || 0,
            pointerEvents: props.pointerEvents ? 'painted' : 'none',
            textAlign: props.textAlignCenter ? 'center' : 'left'
        }}>
            {props.children}
        </div>
    )
}